import { IDataSet } from '../Track';

export class UserDataSet implements IDataSet {
    /** New userID after user unification */
    public newUserID: string = undefined;

    /** userID associated with account before user unification*/
    public formerUserID: string = undefined;
}
